<template>
  <div class="order-detail-header">
    <img
      :src="image"
      width="48"
      height="48"
      alt="ไม่พบเลขที่ใบจองหรือทำรายการไม่สำเร็จ"
    />

    <div>
      <div class="title-medium">{{ orderLabel }} #{{ order }}</div>
      <div>
        <div class="headline-m">
          <slot name="title">{{ title }}</slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderDetailHeader',
  props: {
    image: {
      type: String,
    },
    orderLabel: {
      type: String,
      default: 'รายการสั่งซื้อ',
    },
    order: {
      type: String,
    },
    title: {
      type: String,
    },
  },
}
</script>

<style lang="stylus" scoped>
.order-detail-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.title-medium {
   text-transform: uppercase;
}

.headline-m {
    white-space: pre-line;
}
</style>
